import { render } from "./ZoneWizardRegisterTemplate.vue?vue&type=template&id=b5b2a820&scoped=true"
import script from "./ZoneWizardRegisterTemplate.vue?vue&type=script&lang=js"
export * from "./ZoneWizardRegisterTemplate.vue?vue&type=script&lang=js"

import "./ZoneWizardRegisterTemplate.vue?vue&type=style&index=0&id=b5b2a820&lang=less&scoped=true"

import exportComponent from "/build/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b5b2a820"]])

export default __exports__